import { type AircraftData, type AircraftSubStatus } from '#entities';
import { EAircraftEventType } from '#shared';

export const getAircraftSubStatus = (
  aircraftData: AircraftData,
): AircraftSubStatus | null => {
  const actualEvent = aircraftData.aircraftEvents[0];
  if (actualEvent?.type === EAircraftEventType.Trip) {
    if (aircraftData.actualOrgan) {
      return 'OnCase';
    }
    return 'OnNonCase';
  } else if (actualEvent?.type === EAircraftEventType.Maintenance) {
    return aircraftData.maintenanceType?.OpsBoardBadge ?? null;
  }
  return null;
};
